import gql from 'graphql-tag';
import { DEAL_CALL_ACTIVITY_FRAGMENT } from './fragments/dealCallActivity.fragment';
import { DEAL_NOTE_ACTIVITY_FRAGMENT } from './fragments/dealNoteActivity.fragment';
import { DEAL_EMAIL_ACTIVITY_FRAGMENT } from './fragments/dealEmailActivity.fragment';
import { DEAL_EVENT_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const DEAL_ACTIVITY = gql`
  query DealActivity($input: DealActivityInput!) {
    dealActivity {
      result: dealActivity(input: $input) {
        error
        success
        entity {
          __typename
          ...DealCallActivityFields
          ...DealNoteActivityFields
          ...DealEmailActivityFields
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_CALL_ACTIVITY_FRAGMENT}
  ${DEAL_NOTE_ACTIVITY_FRAGMENT}
  ${DEAL_EMAIL_ACTIVITY_FRAGMENT}
  ${DEAL_EVENT_ACTIVITY_FRAGMENT}
`;
